import Pikaday from 'pikaday';

const element = document.querySelector('.js-grocery-shipping-method');
const form = document.querySelector('.js-grocery-delivery');

export function init() {
	if (!element) {
		return;
	}

	const deliveryDateInput = document.querySelector('.js-datepicker-delivery');
	const dateError = document.querySelector('.js-order-date-error');
	// const dateRegex = /^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/;
	let shippingDate;
	let shippingDateErrorMessage;

	function formatDate(date) {
		const year = date.getFullYear();
		const month = `${date.getMonth() + 1}`;
		const day = `${date.getDate()}`;
		return [year, month, day].join('-');
	}

	let deliveryDateDatePicker = new Pikaday({
		theme: 'date-picker',
		field: deliveryDateInput,
		toString: formatDate,
		parse(dateString) {
			const parts = dateString.split('-');
			const day = parseInt(parts[0], 10);
			const month = parseInt(parts[1], 10) - 1;
			const year = parseInt(parts[2], 10);

			return new Date(year, month, day);
		},
		disableDayFn: function disableDay(date) {
			return date.getDay() === 0;
		},
	});

	// Prevent onscreen keyboard on iOS, Android, etc.
	deliveryDateInput.setAttribute('inputmode', 'none');

	// deliveryDateInput.setAttribute('disabled', 'true');
	const orderTitle = document.querySelector('.js-order-method');
	const dateLabel = document.querySelector('.js-order-date-label');

	orderTitle.innerText = 'Pre-order';
	dateLabel.innerText = 'Arrival date';

	let date = new Date();
	date.setDate(date.getDate() + 1);

	deliveryDateDatePicker.setMinDate(date);
	shippingDate = formatDate(date);
	shippingDateErrorMessage = 'Date must be next day or after';

	form.addEventListener('submit', (event) => {
		event.preventDefault();
		if (!shippingDate) {
			dateError.classList.add('c-form__freeform-errors');
			dateError.innerHTML = 'Select a delivery method';
			return;
		}

		let datePicked = deliveryDateInput.value;
		// if (!dateRegex.test(datePicked)) {
		// 	dateError.classList.add('c-form__freeform-errors');
		// 	dateError.innerHTML = 'Enter a valid date format YYYY-M-D';
		// 	return;
		// }

		if (date > deliveryDateDatePicker.getDate()) {
			dateError.classList.add('c-form__freeform-errors');
			dateError.innerHTML = shippingDateErrorMessage;
			return;
		}

		if (deliveryDateDatePicker.getDate().getDay() === 0) {
			dateError.classList.add('c-form__freeform-errors');
			dateError.innerHTML = 'Deliveries are unavailable on Sundays';
			return;
		}

		form.submit();
	});
}
